
import React from 'react';

const FAQSection = () => {
  // Create FAQ structured data
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Hoe snel kunnen jullie starten?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Na ons eerste gesprek kunnen we meestal binnen 5 werkdagen beginnen met jouw project. Afhankelijk van jouw wensen en de complexiteit kunnen we snel schakelen."
        }
      },
      {
        "@type": "Question",
        "name": "Wat kost jullie dienstverlening?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Onze diensten beginnen vanaf €395 per maand. We werken met verschillende pakketten die we afstemmen op jouw specifieke behoeften. Tijdens het vrijblijvende gesprek bespreken we de mogelijkheden."
        }
      },
      {
        "@type": "Question",
        "name": "Voor welke sectoren werken jullie?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Wij specialiseren ons in B2B-dienstverlening en hebben jarenlange ervaring in diverse sectoren zoals ICT, financiële diensten, zakelijke dienstverlening, productie en industrie."
        }
      },
      {
        "@type": "Question",
        "name": "Waar werken jullie in België?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Afsprakenmaker is actief in heel Vlaanderen en Brussel. We ondersteunen KMO's in onder andere Antwerpen, Gent, Aalst, Leuven, Hasselt, Brugge en Kortrijk met telefonische prospectie en leadgeneratie."
        }
      },
      {
        "@type": "Question",
        "name": "Hoe meet ik het resultaat van jullie diensten?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We voorzien een persoonlijk dashboard waar je in realtime de resultaten kunt volgen. Daarnaast ontvang je wekelijks een rapportage over de gemaakte afspraken, conversies en andere KPI's die voor jouw bedrijf belangrijk zijn."
        }
      }
    ]
  };

  return (
    <section className="bg-gray-50 py-12 md:py-16 border-t border-gray-200">
      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>
      <div className="container">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">Veelgestelde vragen</h2>
        <div className="max-w-3xl mx-auto space-y-6">
          <div className="bg-white p-6 rounded-lg shadow-sm" itemScope itemType="https://schema.org/Question">
            <h3 className="text-xl font-semibold mb-3" itemProp="name">Hoe snel kunnen jullie starten?</h3>
            <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
              <p className="text-gray-700" itemProp="text">Na ons eerste gesprek kunnen we meestal binnen 5 werkdagen beginnen met jouw project. Afhankelijk van jouw wensen en de complexiteit kunnen we snel schakelen.</p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" itemScope itemType="https://schema.org/Question">
            <h3 className="text-xl font-semibold mb-3" itemProp="name">Wat kost jullie dienstverlening?</h3>
            <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
              <p className="text-gray-700" itemProp="text">Onze diensten beginnen vanaf €395 per maand. We werken met verschillende pakketten die we afstemmen op jouw specifieke behoeften. Tijdens het vrijblijvende gesprek bespreken we de mogelijkheden.</p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" itemScope itemType="https://schema.org/Question">
            <h3 className="text-xl font-semibold mb-3" itemProp="name">Voor welke sectoren werken jullie?</h3>
            <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
              <p className="text-gray-700" itemProp="text">Wij specialiseren ons in B2B-dienstverlening en hebben jarenlange ervaring in diverse sectoren zoals ICT, financiële diensten, zakelijke dienstverlening, productie en industrie.</p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" itemScope itemType="https://schema.org/Question">
            <h3 className="text-xl font-semibold mb-3" itemProp="name">Waar werken jullie in België?</h3>
            <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
              <p className="text-gray-700" itemProp="text">Afsprakenmaker is actief in heel Vlaanderen en Brussel. We ondersteunen KMO's in onder andere Antwerpen, Gent, Aalst, Leuven, Hasselt, Brugge en Kortrijk met telefonische prospectie en leadgeneratie.</p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" itemScope itemType="https://schema.org/Question">
            <h3 className="text-xl font-semibold mb-3" itemProp="name">Hoe meet ik het resultaat van jullie diensten?</h3>
            <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
              <p className="text-gray-700" itemProp="text">We voorzien een persoonlijk dashboard waar je in realtime de resultaten kunt volgen. Daarnaast ontvang je wekelijks een rapportage over de gemaakte afspraken, conversies en andere KPI's die voor jouw bedrijf belangrijk zijn.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
